import { Record, Union } from "../fable_modules/fable-library.4.1.4/Types.js";
import { anonRecord_type, class_type, record_type, bool_type, option_type, tuple_type, list_type, int32_type, string_type, union_type } from "../fable_modules/fable-library.4.1.4/Reflection.js";
import { Core_Creature__get_DR_, Core_Creature__get_Damage_, Core_DamageType, Core_Creature__get_WeaponSkill_, Core_Creature__get_ExtraAttack_, Core_Creature__get_AlteredTimeRate_, Core_Creature__get_HT_, Core_Creature__get_DX_, Core_Creature__get_Speed_, Core_Creature__get_Dodge_, Core_Creature__get_ExtraParry_, Core_SelfControlLevel, Core_Creature__get_HP_, Core_Creature_$reflection } from "./Domain.fs.js";
import { comparePrimitives, numberHash, disposeSafe, getEnumerator, equalArrays, compareArrays, compare, safeHash, curry3, equals } from "../fable_modules/fable-library.4.1.4/Util.js";
import { max as max_2, min as min_2, isEmpty, cons, sumBy, last, collect, length, ofSeq, choose, ofArray, filter, append, contains, exists, empty, singleton } from "../fable_modules/fable-library.4.1.4/List.js";
import { betweenInclusive as betweenInclusive_1, List_includes } from "../Core/Common.fs.js";
import { add, FSharpMap__ContainsKey, empty as empty_2, ofSeq as ofSeq_1, FSharpMap__get_Item, FSharpMap__get_Values, change } from "../fable_modules/fable-library.4.1.4/Map.js";
import { defaultArg, orElse } from "../fable_modules/fable-library.4.1.4/Option.js";
import { List_distinct } from "../fable_modules/fable-library.4.1.4/Seq2.js";
import { min as min_1, max as max_1 } from "../fable_modules/fable-library.4.1.4/Double.js";
import { length as length_1, exists as exists_1, empty as empty_1, append as append_1, delay, toList, map, tryHead, filter as filter_1, sortBy } from "../fable_modules/fable-library.4.1.4/Seq.js";
import { op_UnaryNegation_Int32 } from "../fable_modules/fable-library.4.1.4/Int32.js";
import { CQRS$2__LogWithMessages, CQRS$2_Create_Z5C8122BF, CQRS$2__Execute_2B595, CQRS$2__get_State } from "../Core/CQRS.fs.js";
import { RollSpec__roll, RollSpec_create_Z37302880 } from "./Random.fs.js";
import { interpolate, toText } from "../fable_modules/fable-library.4.1.4/String.js";
import { rangeDouble } from "../fable_modules/fable-library.4.1.4/Range.js";

export class Status extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OK", "Stunned", "Prone", "Unconscious", "Dead", "Berserk"];
    }
}

export function Status_$reflection() {
    return union_type("Domain.FightExecution.Status", [], Status, () => [[], [], [], [], [], []]);
}

export class Combatant extends Record {
    constructor(personalName, number, team, stats, injuryTaken, shockPenalty, statusMods, retreatUsed, blockUsed, parriesUsed) {
        super();
        this.personalName = personalName;
        this.number = (number | 0);
        this.team = (team | 0);
        this.stats = stats;
        this.injuryTaken = (injuryTaken | 0);
        this.shockPenalty = (shockPenalty | 0);
        this.statusMods = statusMods;
        this.retreatUsed = retreatUsed;
        this.blockUsed = blockUsed;
        this.parriesUsed = (parriesUsed | 0);
    }
}

export function Combatant_$reflection() {
    return record_type("Domain.FightExecution.Combatant", [], Combatant, () => [["personalName", string_type], ["number", int32_type], ["team", int32_type], ["stats", Core_Creature_$reflection()], ["injuryTaken", int32_type], ["shockPenalty", int32_type], ["statusMods", list_type(Status_$reflection())], ["retreatUsed", option_type(tuple_type(int32_type, string_type))], ["blockUsed", bool_type], ["parriesUsed", int32_type]]);
}

export function Combatant__get_CurrentHP_(this$) {
    return Core_Creature__get_HP_(this$.stats) - this$.injuryTaken;
}

export function Combatant__get_Id(this$) {
    return [this$.team, this$.personalName];
}

export function Combatant_fresh_Z5A3DD3BA(team, name, number, stats) {
    return new Combatant(name, number, team, stats, 0, 0, equals(stats.Berserk, new Core_SelfControlLevel(4, [])) ? singleton(new Status(5, [])) : empty(), void 0, false, 0);
}

export function Combatant__is_Z625EB0E9(this$, status) {
    return exists((y) => equals(status, y), this$.statusMods);
}

export function Combatant__isAny_Z3ABD908B(this$, statuses) {
    return List_includes(statuses)(this$.statusMods);
}

export function Combatant__isnt_Z625EB0E9(this$, status) {
    return !Combatant__is_Z625EB0E9(this$, status);
}

export function Combatant__isnt_Z3ABD908B(this$, statuses) {
    return !Combatant__isAny_Z3ABD908B(this$, statuses);
}

export class Combat extends Record {
    constructor(combatants) {
        super();
        this.combatants = combatants;
    }
}

export function Combat_$reflection() {
    return record_type("Domain.FightExecution.Combat", [], Combat, () => [["combatants", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [tuple_type(int32_type, string_type), Combatant_$reflection()])]]);
}

export class Ids extends Record {
    constructor(attacker, target) {
        super();
        this.attacker = attacker;
        this.target = target;
    }
}

export function Ids_$reflection() {
    return record_type("Domain.FightExecution.Ids", [], Ids, () => [["attacker", tuple_type(int32_type, string_type)], ["target", tuple_type(int32_type, string_type)]]);
}

export function Ids__get_Attacker_(this$) {
    return this$.attacker[1];
}

export function Ids__get_AttackerTeam_(this$) {
    return this$.attacker[0];
}

export function Ids__get_Target_(this$) {
    return this$.target[1];
}

export function Ids__get_TargetTeam_(this$) {
    return this$.target[0];
}

export class DefenseType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Parry", "Block", "Dodge"];
    }
}

export function DefenseType_$reflection() {
    return union_type("Domain.FightExecution.DefenseType", [], DefenseType, () => [[], [], []]);
}

export class DefenseDetails extends Record {
    constructor(defense, retreatFrom) {
        super();
        this.defense = defense;
        this.retreatFrom = retreatFrom;
    }
}

export function DefenseDetails_$reflection() {
    return record_type("Domain.FightExecution.DefenseDetails", [], DefenseDetails, () => [["defense", DefenseType_$reflection()], ["retreatFrom", option_type(tuple_type(int32_type, string_type))]]);
}

export function DefenseDetails__get_targetRetreated(this$) {
    return this$.retreatFrom != null;
}

export class CombatEvents_Event extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Hit", "SuccessfulDefense", "Miss", "FallUnconscious", "Unstun", "StandUp", "Info", "NewRound"];
    }
}

export function CombatEvents_Event_$reflection() {
    return union_type("Domain.FightExecution.CombatEvents.Event", [], CombatEvents_Event, () => [[["Item1", Ids_$reflection()], ["Item2", option_type(DefenseDetails_$reflection())], ["injury", int32_type], ["Item4", list_type(Status_$reflection())], ["Item5", string_type]], [["Item1", Ids_$reflection()], ["Item2", DefenseDetails_$reflection()], ["Item3", string_type]], [["Item1", Ids_$reflection()], ["Item2", string_type]], [["Item1", tuple_type(int32_type, string_type)], ["Item2", string_type]], [["Item1", tuple_type(int32_type, string_type)], ["Item2", string_type]], [["Item1", tuple_type(int32_type, string_type)], ["Item2", string_type]], [["Item1", tuple_type(int32_type, string_type)], ["msg", string_type], ["rollInfo", string_type]], [["Item", int32_type]]]);
}

export function CombatEvents_update(msg, model) {
    const updateCombatant = (id, f, model_1) => (new Combat(change(id, (_arg) => {
        if (_arg == null) {
            return void 0;
        }
        else {
            return f(_arg);
        }
    }, model_1.combatants)));
    const consumeDefense = (id_1) => ((defense) => curry3(updateCombatant)(id_1)((c_1) => {
        if (defense == null) {
            return c_1;
        }
        else {
            const defense_1 = defense;
            return new Combatant(c_1.personalName, c_1.number, c_1.team, c_1.stats, c_1.injuryTaken, c_1.shockPenalty, c_1.statusMods, orElse(c_1.retreatUsed, defense_1.retreatFrom), c_1.blockUsed ? true : equals(defense_1.defense, new DefenseType(1, [])), c_1.parriesUsed + (equals(defense_1.defense, new DefenseType(0, [])) ? 1 : 0));
        }
    }));
    const newTurn = (id_2) => curry3(updateCombatant)(id_2)((c_2) => (new Combatant(c_2.personalName, c_2.number, c_2.team, c_2.stats, c_2.injuryTaken, 0, c_2.statusMods, void 0, false, 0)));
    const takeDamage = (id_3) => ((amount) => ((conditions) => curry3(updateCombatant)(id_3)((c_3) => {
        const goingBerserk = contains(new Status(5, []), conditions, {
            Equals: equals,
            GetHashCode: safeHash,
        });
        const mods$0027 = List_distinct(append(c_3.statusMods, conditions), {
            Equals: equals,
            GetHashCode: safeHash,
        });
        return new Combatant(c_3.personalName, c_3.number, c_3.team, c_3.stats, c_3.injuryTaken + amount, ((c_3.stats.SupernaturalDurability ? true : c_3.stats.HighPainThreshold) ? true : contains(new Status(5, []), mods$0027, {
            Equals: equals,
            GetHashCode: safeHash,
        })) ? 0 : max_1(-4, c_3.shockPenalty - ~~(amount / max_1(1, ~~(Core_Creature__get_HP_(c_3.stats) / 10)))), goingBerserk ? filter((y_3) => !equals(new Status(1, []), y_3), mods$0027) : mods$0027, c_3.retreatUsed, c_3.blockUsed, c_3.parriesUsed);
    })));
    switch (msg.tag) {
        case 1: {
            const ids_1 = msg.fields[0];
            return consumeDefense(ids_1.target)(msg.fields[1])(newTurn(ids_1.attacker)(model));
        }
        case 2:
            return newTurn(msg.fields[0].attacker)(model);
        case 3: {
            const id_4 = msg.fields[0];
            return takeDamage(id_4)(0)(singleton(new Status(3, [])))(newTurn(id_4)(model));
        }
        case 4: {
            const id_5 = msg.fields[0];
            return updateCombatant(id_5, (c_4) => (new Combatant(c_4.personalName, c_4.number, c_4.team, c_4.stats, c_4.injuryTaken, c_4.shockPenalty, filter((y_4) => !equals(new Status(1, []), y_4), c_4.statusMods), c_4.retreatUsed, c_4.blockUsed, c_4.parriesUsed)), newTurn(id_5)(model));
        }
        case 5: {
            const id_6 = msg.fields[0];
            return updateCombatant(id_6, (c_5) => (new Combatant(c_5.personalName, c_5.number, c_5.team, c_5.stats, c_5.injuryTaken, c_5.shockPenalty, filter((y_5) => !equals(new Status(2, []), y_5), c_5.statusMods), c_5.retreatUsed, c_5.blockUsed, c_5.parriesUsed)), newTurn(id_6)(model));
        }
        case 6:
            return newTurn(msg.fields[0])(model);
        case 7:
            return model;
        default: {
            const ids = msg.fields[0];
            return takeDamage(ids.target)(msg.fields[2])(msg.fields[3])(consumeDefense(ids.target)(msg.fields[1])(newTurn(ids.attacker)(model)));
        }
    }
}

export class DefeatCriteria extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TPK", "OneCasualty", "HalfCasualties"];
    }
}

export function DefeatCriteria_$reflection() {
    return union_type("Domain.FightExecution.DefeatCriteria", [], DefeatCriteria, () => [[], [], []]);
}

export class FightResult extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CalibratedResult", "SpecificResult"];
    }
}

export function FightResult_$reflection() {
    return union_type("Domain.FightExecution.FightResult", [], FightResult, () => [[["lower", option_type(int32_type)], ["upper", option_type(int32_type)], ["sample", list_type(tuple_type(option_type(CombatEvents_Event_$reflection()), Combat_$reflection()))]], [["Item1", list_type(tuple_type(option_type(CombatEvents_Event_$reflection()), Combat_$reflection()))], ["Item2", anonRecord_type(["victors", list_type(int32_type)])]]]);
}

export class Outcome extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CritSuccess", "Success", "CritFail", "Fail"];
    }
}

export function Outcome_$reflection() {
    return union_type("Domain.FightExecution.Outcome", [], Outcome, () => [[["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]]]);
}

export function successTest(target, x) {
    if (x >= (target + 10)) {
        return new Outcome(2, [x - target]);
    }
    else {
        switch (x) {
            case 17:
                if (target >= 16) {
                    return new Outcome(3, [x - 16]);
                }
                else {
                    return new Outcome(2, [x - 16]);
                }
            case 18:
                return new Outcome(2, [x - target]);
            default:
                if (x > target) {
                    return new Outcome(3, [x - target]);
                }
                else if ((target >= 16) && (x <= 6)) {
                    return new Outcome(0, [min_1(target, 6) - x]);
                }
                else if ((target >= 15) && (x <= 5)) {
                    return new Outcome(0, [min_1(target, 5) - x]);
                }
                else if (x <= 4) {
                    return new Outcome(0, [min_1(target, 4) - x]);
                }
                else {
                    return new Outcome(1, [target - x]);
                }
        }
    }
}

export function prioritizeTargets(combat, attacker) {
    return sortBy((c_2) => {
        let tupledArg, x;
        return [!(Combatant__is_Z625EB0E9(c_2, new Status(1, [])) && (Combatant__get_CurrentHP_(c_2) > op_UnaryNegation_Int32(Core_Creature__get_HP_(c_2.stats)))), !(Combatant__is_Z625EB0E9(c_2, new Status(2, [])) && (Combatant__get_CurrentHP_(c_2) > op_UnaryNegation_Int32(Core_Creature__get_HP_(c_2.stats)))), !((tupledArg = [0, ~~((Core_Creature__get_HP_(c_2.stats) + 1) / 3)], (x = (Combatant__get_CurrentHP_(c_2) | 0), (compare(tupledArg[0], x) <= 0) && (compare(x, tupledArg[1]) <= 0)))), (Combatant__get_CurrentHP_(c_2) <= 0) && !c_2.stats.SupernaturalDurability, c_2.number];
    }, filter_1((c_1) => !Combatant__isAny_Z3ABD908B(c_1, ofArray([new Status(4, []), new Status(3, [])])), filter_1((c) => (c.team !== attacker.team), FSharpMap__get_Values(combat.combatants))), {
        Compare: compareArrays,
    });
}

export function tryFindTarget(combat, attacker) {
    return tryHead(prioritizeTargets(combat, attacker));
}

export function chooseDefense(attacker, victim) {
    let id_1, retreat_5, retreat_3, retreat_1, parry_3;
    const attackerId = Combatant__get_Id(attacker);
    let canRetreat;
    if (!Combatant__isAny_Z3ABD908B(victim, ofArray([new Status(4, []), new Status(3, []), new Status(1, [])]))) {
        const matchValue = victim.retreatUsed;
        canRetreat = ((matchValue == null) ? true : (equalArrays(matchValue, attackerId) && ((id_1 = matchValue, true))));
    }
    else {
        canRetreat = false;
    }
    const $007CParry$007C_$007C = (_arg) => {
        let matchValue_2, parry;
        let matchResult, parry_1;
        if (_arg != null) {
            if ((parry = (_arg | 0), !attacker.stats.CannotBeParried)) {
                matchResult = 0;
                parry_1 = _arg;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const parry_2 = (parry_1 - (((matchValue_2 = victim.stats.FencingParry, victim.stats.WeaponMaster ? (matchValue_2 ? 1 : 2) : (matchValue_2 ? 2 : 4))) * ~~(victim.parriesUsed / (1 + Core_Creature__get_ExtraParry_(victim.stats))))) | 0;
                return canRetreat ? [(victim.stats.FencingParry ? 3 : 1) + parry_2, attackerId] : [parry_2, void 0];
            }
            default:
                return void 0;
        }
    };
    const $007CBlock$007C_$007C = (_arg_1) => {
        let block;
        let matchResult_1, block_1;
        if (_arg_1 != null) {
            if ((block = (_arg_1 | 0), victim.blockUsed === false)) {
                matchResult_1 = 0;
                block_1 = _arg_1;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0:
                return canRetreat ? [1 + block_1, attackerId] : [block_1, void 0];
            default:
                return void 0;
        }
    };
    let patternInput;
    const dodge = ((Combatant__get_CurrentHP_(victim) >= (Core_Creature__get_HP_(victim.stats) / 3)) ? Core_Creature__get_Dodge_(victim.stats) : ~~(Core_Creature__get_Dodge_(victim.stats) / 2)) | 0;
    patternInput = (canRetreat ? [3 + dodge, attackerId] : [dodge, void 0]);
    const dodge_1 = patternInput[0] | 0;
    let patternInput_1;
    const matchValue_4 = victim.stats.Parry;
    const matchValue_5 = victim.stats.Block;
    let matchResult_2, block_3, parry_4, retreat_2;
    const activePatternResult = $007CParry$007C_$007C(matchValue_4);
    if (activePatternResult != null) {
        const activePatternResult_1 = $007CBlock$007C_$007C(matchValue_5);
        if (activePatternResult_1 != null) {
            if ((retreat_1 = activePatternResult[1], (parry_3 = (activePatternResult[0] | 0), (parry_3 >= activePatternResult_1[0]) && (parry_3 >= dodge_1)))) {
                matchResult_2 = 0;
                block_3 = activePatternResult_1[0];
                parry_4 = activePatternResult[0];
                retreat_2 = activePatternResult[1];
            }
            else {
                matchResult_2 = 1;
            }
        }
        else {
            matchResult_2 = 1;
        }
    }
    else {
        matchResult_2 = 1;
    }
    switch (matchResult_2) {
        case 0: {
            patternInput_1 = [parry_4, new DefenseDetails(new DefenseType(0, []), retreat_2)];
            break;
        }
        default: {
            let matchResult_3, block_5, retreat_4;
            const activePatternResult_2 = $007CBlock$007C_$007C(matchValue_5);
            if (activePatternResult_2 != null) {
                if ((retreat_3 = activePatternResult_2[1], activePatternResult_2[0] >= dodge_1)) {
                    matchResult_3 = 0;
                    block_5 = activePatternResult_2[0];
                    retreat_4 = activePatternResult_2[1];
                }
                else {
                    matchResult_3 = 1;
                }
            }
            else {
                matchResult_3 = 1;
            }
            switch (matchResult_3) {
                case 0: {
                    patternInput_1 = [block_5, new DefenseDetails(new DefenseType(1, []), retreat_4)];
                    break;
                }
                default: {
                    let matchResult_4, parry_6, retreat_6;
                    const activePatternResult_3 = $007CParry$007C_$007C(matchValue_4);
                    if (activePatternResult_3 != null) {
                        if ((retreat_5 = activePatternResult_3[1], activePatternResult_3[0] >= dodge_1)) {
                            matchResult_4 = 0;
                            parry_6 = activePatternResult_3[0];
                            retreat_6 = activePatternResult_3[1];
                        }
                        else {
                            matchResult_4 = 1;
                        }
                    }
                    else {
                        matchResult_4 = 1;
                    }
                    switch (matchResult_4) {
                        case 0: {
                            patternInput_1 = [parry_6, new DefenseDetails(new DefenseType(0, []), retreat_6)];
                            break;
                        }
                        default:
                            patternInput_1 = [dodge_1, new DefenseDetails(new DefenseType(2, []), patternInput[1])];
                    }
                }
            }
        }
    }
    return [(patternInput_1[0] + (Combatant__is_Z625EB0E9(victim, new Status(1, [])) ? -4 : 0)) + (Combatant__is_Z625EB0E9(victim, new Status(2, [])) ? -3 : 0), patternInput_1[1]];
}

export function failedDeathcheck(attempt, fullHP, priorHP, newHP) {
    if (newHP <= (fullHP * -1)) {
        const oldBracket = min_1(0, ~~(priorHP / fullHP)) | 0;
        const checksNeeded = (oldBracket - ~~(newHP / fullHP)) | 0;
        const loop = (checksFinished_mut) => {
            loop:
            while (true) {
                const checksFinished = checksFinished_mut;
                if (checksFinished === checksNeeded) {
                    return false;
                }
                else if (attempt(((op_UnaryNegation_Int32(oldBracket) + 1) + checksFinished) * op_UnaryNegation_Int32(fullHP)) === false) {
                    return true;
                }
                else {
                    checksFinished_mut = (checksFinished + 1);
                    continue loop;
                }
                break;
            }
        };
        return loop(0);
    }
    else {
        return false;
    }
}

export function fightOneRound(cqrs) {
    let matchValue_2, victim, patternInput_1, rapidStrikePenalty, penalty_1, matchValue_3, n_2, deceptive, matchValue_4, patternInput_2, defense, defenseLabel, matchValue_5, critSuccess, defense_1, damageCap, dmg, penetratingDmg, toInjury, injury, injury_2, matchValue_8, r, r_1, followupType, followup, injury_1, newConditions, berserk, matchValue_11, berserkLevel, berserkLevel_1, target, hp$0027, autodeathThreshold;
    const enumerator = getEnumerator(map(Combatant__get_Id, sortBy((c) => [-Core_Creature__get_Speed_(c.stats), op_UnaryNegation_Int32(Core_Creature__get_DX_(c.stats)), c.stats.name, c.number], FSharpMap__get_Values(CQRS$2__get_State(cqrs).combatants), {
        Compare: compareArrays,
    })));
    try {
        while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
            const c_2 = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            const roll3d6 = RollSpec_create_Z37302880(3, 6);
            let msg = "";
            const recordMsg = (txt) => {
                if (msg === "") {
                    msg = txt;
                }
                else {
                    msg = (`${msg}; ${txt}`);
                }
            };
            const detailedAttempt = (label, targetNumber) => {
                const roll = RollSpec__roll(roll3d6) | 0;
                const matchValue = successTest(targetNumber, roll);
                switch (matchValue.tag) {
                    case 1: {
                        recordMsg(`${label} succeeded (target ${targetNumber}, rolled ${roll})`);
                        return matchValue;
                    }
                    case 3: {
                        recordMsg(`${label} failed (target ${targetNumber}, rolled ${roll})`);
                        return matchValue;
                    }
                    case 2: {
                        recordMsg(`${label} failed (target ${targetNumber}, rolled ${roll})`);
                        return matchValue;
                    }
                    default: {
                        recordMsg(`${label} critically succeeded (target ${targetNumber}, rolled ${roll})`);
                        return matchValue;
                    }
                }
            };
            const attempt = (label_1, targetNumber_1) => {
                const matchValue_1 = detailedAttempt(label_1, targetNumber_1);
                let matchResult, success_2;
                switch (matchValue_1.tag) {
                    case 2:
                    case 3: {
                        matchResult = 1;
                        break;
                    }
                    case 1: {
                        matchResult = 0;
                        success_2 = matchValue_1;
                        break;
                    }
                    default: {
                        matchResult = 0;
                        success_2 = matchValue_1;
                    }
                }
                switch (matchResult) {
                    case 0:
                        return true;
                    default:
                        return false;
                }
            };
            const checkGoesUnconscious = (tupledArg, incomingDamage) => {
                const self = tupledArg[0];
                const penalty = ~~((Combatant__get_CurrentHP_(self) - incomingDamage) / Core_Creature__get_HP_(self.stats)) | 0;
                return !attempt("Stay conscious", (Core_Creature__get_HT_(self.stats) + penalty) + (tupledArg[1] ? 4 : 0));
            };
            let doneEarly = false;
            const attacker = FSharpMap__get_Item(CQRS$2__get_State(cqrs).combatants, c_2);
            if (Combatant__isnt_Z3ABD908B(attacker, ofArray([new Status(4, []), new Status(3, [])]))) {
                if (Combatant__is_Z625EB0E9(attacker, new Status(1, []))) {
                    CQRS$2__Execute_2B595(cqrs, attempt("Recover from stun", Core_Creature__get_HT_(attacker.stats)) ? (new CombatEvents_Event(4, [Combatant__get_Id(attacker), msg])) : (new CombatEvents_Event(6, [Combatant__get_Id(attacker), "does nothing", msg])));
                }
                else if (((Combatant__get_CurrentHP_(attacker) <= 0) && !attacker.stats.SupernaturalDurability) && checkGoesUnconscious([attacker, Combatant__is_Z625EB0E9(attacker, new Status(5, []))], 0)) {
                    CQRS$2__Execute_2B595(cqrs, new CombatEvents_Event(3, [Combatant__get_Id(attacker), msg]));
                }
                else if (Combatant__is_Z625EB0E9(attacker, new Status(2, []))) {
                    CQRS$2__Execute_2B595(cqrs, new CombatEvents_Event(5, [Combatant__get_Id(attacker), msg]));
                }
                else {
                    for (let m = 1; m <= (1 + Core_Creature__get_AlteredTimeRate_(attacker.stats)); m++) {
                        const patternInput = attacker.stats.UseRapidStrike ? [2 + Core_Creature__get_ExtraAttack_(attacker.stats), 2] : [1 + Core_Creature__get_ExtraAttack_(attacker.stats), 0];
                        const totalAttacks = patternInput[0] | 0;
                        const totalAttacks_1 = (Combatant__is_Z625EB0E9(attacker, new Status(5, [])) ? (totalAttacks + 1) : totalAttacks) | 0;
                        for (let n = 1; n <= totalAttacks_1; n++) {
                            if (!doneEarly) {
                                CQRS$2__Execute_2B595(cqrs, (matchValue_2 = tryFindTarget(CQRS$2__get_State(cqrs), attacker), (matchValue_2 == null) ? ((doneEarly = true, new CombatEvents_Event(6, [Combatant__get_Id(attacker), "can\'t find a victim", msg]))) : ((victim = matchValue_2, (patternInput_1 = ((rapidStrikePenalty = (((n <= patternInput[1]) ? ((penalty_1 = ((attacker.stats.WeaponMaster ? -3 : -6) | 0), (recordMsg(toText(interpolate("Using Rapid Strike %+d%P()", [penalty_1]))), penalty_1))) : 0) | 0), ((attacker.shockPenalty !== 0) ? recordMsg(toText(interpolate("Shock penalty %+d%P()", [attacker.shockPenalty]))) : void 0, (matchValue_3 = (((Core_Creature__get_WeaponSkill_(attacker.stats) + attacker.shockPenalty) + rapidStrikePenalty) | 0), (matchValue_3 >= 18) ? ((n_2 = (matchValue_3 | 0), (deceptive = (~~((n_2 - 16) / 2) | 0), (recordMsg(`Using Deceptive Attack ${-2 * deceptive}`), [n_2 - (deceptive * 2), deceptive])))) : [matchValue_3, 0])))), (matchValue_4 = detailedAttempt("Attack", patternInput_1[0]), (matchValue_4.tag === 0) ? ((patternInput_2 = chooseDefense(attacker, victim), (defense = patternInput_2[1], (defenseLabel = (((matchValue_5 = defense.defense, (matchValue_5.tag === 1) ? "Block" : ((matchValue_5.tag === 2) ? "Dodge" : "Parry"))) + (DefenseDetails__get_targetRetreated(defense) ? " and retreat" : "")), (critSuccess = (matchValue_4.tag === 0), (!(critSuccess ? true : Combatant__is_Z625EB0E9(victim, new Status(5, []))) && attempt(defenseLabel, patternInput_2[0] - patternInput_1[1])) ? (new CombatEvents_Event(1, [new Ids(Combatant__get_Id(attacker), Combatant__get_Id(victim)), defense, msg])) : ((defense_1 = (critSuccess ? void 0 : defense), (damageCap = ((damageType) => {
                                    const e = (equals(damageType, new Core_DamageType(2, [])) ? 0 : 1) | 0;
                                    return (e_1) => max_1(e, e_1);
                                }), (dmg = (damageCap(attacker.stats.DamageType)(RollSpec__roll(Core_Creature__get_Damage_(attacker.stats))) | 0), (penetratingDmg = (max_1(0, dmg - Core_Creature__get_DR_(victim.stats)) | 0), (toInjury = ((tupledArg_1) => {
                                    const penetratingDmg_1 = tupledArg_1[0] | 0;
                                    const damageType_1 = tupledArg_1[1];
                                    const matchValue_6 = victim.stats.InjuryTolerance;
                                    let matchResult_1;
                                    if (matchValue_6 != null) {
                                        switch (matchValue_6.tag) {
                                            case 1: {
                                                if (damageType_1 != null) {
                                                    switch (damageType_1.tag) {
                                                        case 1: {
                                                            matchResult_1 = 2;
                                                            break;
                                                        }
                                                        case 3: {
                                                            matchResult_1 = 3;
                                                            break;
                                                        }
                                                        case 0: {
                                                            matchResult_1 = 6;
                                                            break;
                                                        }
                                                        default:
                                                            matchResult_1 = 8;
                                                    }
                                                }
                                                else {
                                                    matchResult_1 = 8;
                                                }
                                                break;
                                            }
                                            case 0: {
                                                if (damageType_1 != null) {
                                                    switch (damageType_1.tag) {
                                                        case 1: {
                                                            matchResult_1 = 4;
                                                            break;
                                                        }
                                                        case 3: {
                                                            matchResult_1 = 5;
                                                            break;
                                                        }
                                                        case 0: {
                                                            matchResult_1 = 6;
                                                            break;
                                                        }
                                                        default:
                                                            matchResult_1 = 8;
                                                    }
                                                }
                                                else {
                                                    matchResult_1 = 8;
                                                }
                                                break;
                                            }
                                            default:
                                                if (damageType_1 != null) {
                                                    switch (damageType_1.tag) {
                                                        case 1:
                                                        case 3: {
                                                            matchResult_1 = 0;
                                                            break;
                                                        }
                                                        default:
                                                            matchResult_1 = 1;
                                                    }
                                                }
                                                else {
                                                    matchResult_1 = 1;
                                                }
                                        }
                                    }
                                    else if (damageType_1 != null) {
                                        switch (damageType_1.tag) {
                                            case 0: {
                                                matchResult_1 = 6;
                                                break;
                                            }
                                            case 1: {
                                                matchResult_1 = 7;
                                                break;
                                            }
                                            default:
                                                matchResult_1 = 8;
                                        }
                                    }
                                    else {
                                        matchResult_1 = 8;
                                    }
                                    switch (matchResult_1) {
                                        case 0:
                                            return max_1(1, penetratingDmg_1) | 0;
                                        case 1:
                                            return max_1(2, penetratingDmg_1) | 0;
                                        case 2:
                                            return ~~(penetratingDmg_1 / 2) | 0;
                                        case 3:
                                            return ~~(penetratingDmg_1 / 5) | 0;
                                        case 4:
                                            return penetratingDmg_1 | 0;
                                        case 5:
                                            return ~~(penetratingDmg_1 / 3) | 0;
                                        case 6:
                                            return ~~(penetratingDmg_1 * 1.5) | 0;
                                        case 7:
                                            return (penetratingDmg_1 * 2) | 0;
                                        default:
                                            return penetratingDmg_1 | 0;
                                    }
                                }), (injury = (toInjury([penetratingDmg, attacker.stats.DamageType]) | 0), (injury_2 = (((matchValue_8 = attacker.stats.FollowupDamage, (matchValue_8 != null) ? (((r = matchValue_8, penetratingDmg > 0)) ? ((r_1 = matchValue_8, (followupType = attacker.stats.FollowupDamageType, (followup = (damageCap(attacker.stats.FollowupDamageType)(RollSpec__roll(r_1)) | 0), (injury_1 = ((injury + toInjury([followup, followupType])) | 0), (recordMsg(`Damage ${Core_Creature__get_Damage_(attacker.stats)} + ${r_1} (${dmg} ${defaultArg(attacker.stats.DamageType, new Core_DamageType(5, []))}, ${followup} ${defaultArg(followupType, new Core_DamageType(5, []))}) - DR ${Core_Creature__get_DR_(victim.stats)} = ${injury_1} injury`), injury_1)))))) : ((recordMsg(`Damage ${Core_Creature__get_Damage_(attacker.stats)} (${dmg} ${defaultArg(attacker.stats.DamageType, new Core_DamageType(5, []))}) - DR ${Core_Creature__get_DR_(victim.stats)} = ${injury} injury`), injury))) : ((recordMsg(`Damage ${Core_Creature__get_Damage_(attacker.stats)} (${dmg} ${defaultArg(attacker.stats.DamageType, new Core_DamageType(5, []))}) - DR ${Core_Creature__get_DR_(victim.stats)} = ${injury} injury`), injury)))) | 0), (newConditions = empty(), (berserk = Combatant__is_Z625EB0E9(victim, new Status(5, [])), ((matchValue_11 = victim.stats.Berserk, (matchValue_11 != null) ? (((berserkLevel = matchValue_11, (injury_2 > (Core_Creature__get_HP_(victim.stats) / 4)) && Combatant__isnt_Z625EB0E9(victim, new Status(5, [])))) ? ((berserkLevel_1 = matchValue_11, (target = (((berserkLevel_1.tag === 1) ? 12 : ((berserkLevel_1.tag === 2) ? 9 : ((berserkLevel_1.tag === 3) ? 6 : ((berserkLevel_1.tag === 4) ? 0 : 15)))) | 0), ((RollSpec__roll(roll3d6) <= target) === false) ? ((recordMsg(`${victim.personalName} goes berserk`), (newConditions = append(newConditions, singleton(new Status(5, []))), berserk = true))) : void 0))) : void 0) : void 0), (hp$0027 = ((Combatant__get_CurrentHP_(victim) - injury_2) | 0), (autodeathThreshold = ((Core_Creature__get_HP_(victim.stats) * (victim.stats.UnnaturallyFragile ? -1 : -5)) | 0), ((hp$0027 <= autodeathThreshold) ? ((recordMsg(`Auto-death occurs at ${autodeathThreshold} HP`), newConditions = singleton(new Status(4, [])))) : (failedDeathcheck((threshold) => attempt(`Deathcheck at ${threshold} HP`, Core_Creature__get_HT_(victim.stats) + (berserk ? 4 : 0)), Core_Creature__get_HP_(victim.stats), Combatant__get_CurrentHP_(victim), hp$0027) ? (newConditions = singleton(new Status(4, []))) : (((((Combatant__get_CurrentHP_(victim) > 0) && (hp$0027 <= 0)) && !victim.stats.SupernaturalDurability) && checkGoesUnconscious([victim, berserk], injury_2)) ? (newConditions = singleton(new Status(3, []))) : ((((injury_2 > ~~((Core_Creature__get_HP_(victim.stats) + 1) / 2)) && !(victim.stats.SupernaturalDurability ? true : berserk)) && !attempt("Knockdown check", Core_Creature__get_HT_(victim.stats) + (victim.stats.HighPainThreshold ? 3 : 0))) ? (newConditions = ofArray([new Status(1, []), new Status(2, [])])) : void 0))), new CombatEvents_Event(0, [new Ids(Combatant__get_Id(attacker), Combatant__get_Id(victim)), defense_1, injury_2, newConditions, msg])))))))))))))))))))) : ((matchValue_4.tag === 3) ? (new CombatEvents_Event(2, [new Ids(Combatant__get_Id(attacker), Combatant__get_Id(victim)), msg])) : ((matchValue_4.tag === 2) ? (new CombatEvents_Event(2, [new Ids(Combatant__get_Id(attacker), Combatant__get_Id(victim)), msg])) : ((patternInput_2 = chooseDefense(attacker, victim), (defense = patternInput_2[1], (defenseLabel = (((matchValue_5 = defense.defense, (matchValue_5.tag === 1) ? "Block" : ((matchValue_5.tag === 2) ? "Dodge" : "Parry"))) + (DefenseDetails__get_targetRetreated(defense) ? " and retreat" : "")), (critSuccess = (matchValue_4.tag === 0), (!(critSuccess ? true : Combatant__is_Z625EB0E9(victim, new Status(5, []))) && attempt(defenseLabel, patternInput_2[0] - patternInput_1[1])) ? (new CombatEvents_Event(1, [new Ids(Combatant__get_Id(attacker), Combatant__get_Id(victim)), defense, msg])) : ((defense_1 = (critSuccess ? void 0 : defense), (damageCap = ((damageType) => {
                                    const e = (equals(damageType, new Core_DamageType(2, [])) ? 0 : 1) | 0;
                                    return (e_1) => max_1(e, e_1);
                                }), (dmg = (damageCap(attacker.stats.DamageType)(RollSpec__roll(Core_Creature__get_Damage_(attacker.stats))) | 0), (penetratingDmg = (max_1(0, dmg - Core_Creature__get_DR_(victim.stats)) | 0), (toInjury = ((tupledArg_1) => {
                                    const penetratingDmg_1 = tupledArg_1[0] | 0;
                                    const damageType_1 = tupledArg_1[1];
                                    const matchValue_6 = victim.stats.InjuryTolerance;
                                    let matchResult_2;
                                    if (matchValue_6 != null) {
                                        switch (matchValue_6.tag) {
                                            case 1: {
                                                if (damageType_1 != null) {
                                                    switch (damageType_1.tag) {
                                                        case 1: {
                                                            matchResult_2 = 2;
                                                            break;
                                                        }
                                                        case 3: {
                                                            matchResult_2 = 3;
                                                            break;
                                                        }
                                                        case 0: {
                                                            matchResult_2 = 6;
                                                            break;
                                                        }
                                                        default:
                                                            matchResult_2 = 8;
                                                    }
                                                }
                                                else {
                                                    matchResult_2 = 8;
                                                }
                                                break;
                                            }
                                            case 0: {
                                                if (damageType_1 != null) {
                                                    switch (damageType_1.tag) {
                                                        case 1: {
                                                            matchResult_2 = 4;
                                                            break;
                                                        }
                                                        case 3: {
                                                            matchResult_2 = 5;
                                                            break;
                                                        }
                                                        case 0: {
                                                            matchResult_2 = 6;
                                                            break;
                                                        }
                                                        default:
                                                            matchResult_2 = 8;
                                                    }
                                                }
                                                else {
                                                    matchResult_2 = 8;
                                                }
                                                break;
                                            }
                                            default:
                                                if (damageType_1 != null) {
                                                    switch (damageType_1.tag) {
                                                        case 1:
                                                        case 3: {
                                                            matchResult_2 = 0;
                                                            break;
                                                        }
                                                        default:
                                                            matchResult_2 = 1;
                                                    }
                                                }
                                                else {
                                                    matchResult_2 = 1;
                                                }
                                        }
                                    }
                                    else if (damageType_1 != null) {
                                        switch (damageType_1.tag) {
                                            case 0: {
                                                matchResult_2 = 6;
                                                break;
                                            }
                                            case 1: {
                                                matchResult_2 = 7;
                                                break;
                                            }
                                            default:
                                                matchResult_2 = 8;
                                        }
                                    }
                                    else {
                                        matchResult_2 = 8;
                                    }
                                    switch (matchResult_2) {
                                        case 0:
                                            return max_1(1, penetratingDmg_1) | 0;
                                        case 1:
                                            return max_1(2, penetratingDmg_1) | 0;
                                        case 2:
                                            return ~~(penetratingDmg_1 / 2) | 0;
                                        case 3:
                                            return ~~(penetratingDmg_1 / 5) | 0;
                                        case 4:
                                            return penetratingDmg_1 | 0;
                                        case 5:
                                            return ~~(penetratingDmg_1 / 3) | 0;
                                        case 6:
                                            return ~~(penetratingDmg_1 * 1.5) | 0;
                                        case 7:
                                            return (penetratingDmg_1 * 2) | 0;
                                        default:
                                            return penetratingDmg_1 | 0;
                                    }
                                }), (injury = (toInjury([penetratingDmg, attacker.stats.DamageType]) | 0), (injury_2 = (((matchValue_8 = attacker.stats.FollowupDamage, (matchValue_8 != null) ? (((r = matchValue_8, penetratingDmg > 0)) ? ((r_1 = matchValue_8, (followupType = attacker.stats.FollowupDamageType, (followup = (damageCap(attacker.stats.FollowupDamageType)(RollSpec__roll(r_1)) | 0), (injury_1 = ((injury + toInjury([followup, followupType])) | 0), (recordMsg(`Damage ${Core_Creature__get_Damage_(attacker.stats)} + ${r_1} (${dmg} ${defaultArg(attacker.stats.DamageType, new Core_DamageType(5, []))}, ${followup} ${defaultArg(followupType, new Core_DamageType(5, []))}) - DR ${Core_Creature__get_DR_(victim.stats)} = ${injury_1} injury`), injury_1)))))) : ((recordMsg(`Damage ${Core_Creature__get_Damage_(attacker.stats)} (${dmg} ${defaultArg(attacker.stats.DamageType, new Core_DamageType(5, []))}) - DR ${Core_Creature__get_DR_(victim.stats)} = ${injury} injury`), injury))) : ((recordMsg(`Damage ${Core_Creature__get_Damage_(attacker.stats)} (${dmg} ${defaultArg(attacker.stats.DamageType, new Core_DamageType(5, []))}) - DR ${Core_Creature__get_DR_(victim.stats)} = ${injury} injury`), injury)))) | 0), (newConditions = empty(), (berserk = Combatant__is_Z625EB0E9(victim, new Status(5, [])), ((matchValue_11 = victim.stats.Berserk, (matchValue_11 != null) ? (((berserkLevel = matchValue_11, (injury_2 > (Core_Creature__get_HP_(victim.stats) / 4)) && Combatant__isnt_Z625EB0E9(victim, new Status(5, [])))) ? ((berserkLevel_1 = matchValue_11, (target = (((berserkLevel_1.tag === 1) ? 12 : ((berserkLevel_1.tag === 2) ? 9 : ((berserkLevel_1.tag === 3) ? 6 : ((berserkLevel_1.tag === 4) ? 0 : 15)))) | 0), ((RollSpec__roll(roll3d6) <= target) === false) ? ((recordMsg(`${victim.personalName} goes berserk`), (newConditions = append(newConditions, singleton(new Status(5, []))), berserk = true))) : void 0))) : void 0) : void 0), (hp$0027 = ((Combatant__get_CurrentHP_(victim) - injury_2) | 0), (autodeathThreshold = ((Core_Creature__get_HP_(victim.stats) * (victim.stats.UnnaturallyFragile ? -1 : -5)) | 0), ((hp$0027 <= autodeathThreshold) ? ((recordMsg(`Auto-death occurs at ${autodeathThreshold} HP`), newConditions = singleton(new Status(4, [])))) : (failedDeathcheck((threshold) => attempt(`Deathcheck at ${threshold} HP`, Core_Creature__get_HT_(victim.stats) + (berserk ? 4 : 0)), Core_Creature__get_HP_(victim.stats), Combatant__get_CurrentHP_(victim), hp$0027) ? (newConditions = singleton(new Status(4, []))) : (((((Combatant__get_CurrentHP_(victim) > 0) && (hp$0027 <= 0)) && !victim.stats.SupernaturalDurability) && checkGoesUnconscious([victim, berserk], injury_2)) ? (newConditions = singleton(new Status(3, []))) : ((((injury_2 > ~~((Core_Creature__get_HP_(victim.stats) + 1) / 2)) && !(victim.stats.SupernaturalDurability ? true : berserk)) && !attempt("Knockdown check", Core_Creature__get_HT_(victim.stats) + (victim.stats.HighPainThreshold ? 3 : 0))) ? (newConditions = ofArray([new Status(1, []), new Status(2, [])])) : void 0))), new CombatEvents_Event(0, [new Ids(Combatant__get_Id(attacker), Combatant__get_Id(victim)), defense_1, injury_2, newConditions, msg]))))))))))))))))))))))))))));
                                msg = "";
                            }
                        }
                    }
                }
            }
        }
    }
    finally {
        disposeSafe(enumerator);
    }
}

export function fight(cqrs) {
    const loop = (counter_mut) => {
        loop:
        while (true) {
            const counter = counter_mut;
            const survivingTeams = List_distinct(choose((c) => {
                if (Combatant__isnt_Z3ABD908B(c, ofArray([new Status(4, []), new Status(3, [])]))) {
                    return c.team;
                }
                else {
                    return void 0;
                }
            }, ofSeq(FSharpMap__get_Values(CQRS$2__get_State(cqrs).combatants))), {
                Equals: (x, y) => (x === y),
                GetHashCode: numberHash,
            });
            if ((length(survivingTeams) < 2) ? true : (counter > 100)) {
                return {
                    victors: survivingTeams,
                };
            }
            else {
                if (counter > 1) {
                    CQRS$2__Execute_2B595(cqrs, new CombatEvents_Event(7, [counter]));
                }
                fightOneRound(cqrs);
                counter_mut = (counter + 1);
                continue loop;
            }
            break;
        }
    };
    return loop(1);
}

export function toCombatants(db, team) {
    let counter = 0;
    return (tupledArg) => {
        const quantity = tupledArg[0] | 0;
        const name = tupledArg[1];
        return toList(delay(() => append_1(map((i) => Combatant_fresh_Z5A3DD3BA(team, (quantity > 1) ? (`${name} ${i}`) : name, counter + i, FSharpMap__get_Item(db, name)), rangeDouble(1, 1, quantity)), delay(() => {
            counter = ((counter + quantity) | 0);
            return empty_1();
        }))));
    };
}

export function createCombat(db, team1, team2) {
    return new Combat(ofSeq_1(map((c) => [Combatant__get_Id(c), c], append(collect(toCombatants(db, 1), team1), collect(toCombatants(db, 2), team2))), {
        Compare: compareArrays,
    }));
}

export function specificFight(db, team1, team2) {
    const cqrs = CQRS$2_Create_Z5C8122BF(createCombat(db, team1, team2), CombatEvents_update);
    const victors = fight(cqrs);
    return [CQRS$2__LogWithMessages(cqrs), victors];
}

export function calibrate(db, team1, enemyType, minbound, maxbound, defeatCriteria) {
    let loop;
    let results = empty_2({
        Compare: comparePrimitives,
    });
    const get$ = (n_1) => {
        if (FSharpMap__ContainsKey(results, n_1)) {
            return FSharpMap__get_Item(results, n_1);
        }
        else {
            const runs = toList(delay(() => map((run) => {
                const cqrs = CQRS$2_Create_Z5C8122BF(createCombat(db, team1, singleton([n_1, enemyType])), CombatEvents_update);
                return [cqrs, fight(cqrs)];
            }, rangeDouble(1, 1, 10))));
            const sampleLog = CQRS$2__LogWithMessages(last(runs)[0]);
            const victories = sumBy((defeatCriteria.tag === 1) ? ((tupledArg) => (exists_1((c) => {
                if (c.team === 1) {
                    return Combatant__isAny_Z3ABD908B(c, ofArray([new Status(4, []), new Status(3, [])]));
                }
                else {
                    return false;
                }
            }, FSharpMap__get_Values(CQRS$2__get_State(tupledArg[0]).combatants)) ? 0 : 1)) : ((defeatCriteria.tag === 2) ? ((tupledArg_1) => {
                const friendlies = filter_1((c_1) => (c_1.team === 1), FSharpMap__get_Values(CQRS$2__get_State(tupledArg_1[0]).combatants));
                return ((length_1(filter_1((c_2) => Combatant__isAny_Z3ABD908B(c_2, ofArray([new Status(4, []), new Status(3, [])])), friendlies)) >= ~~(length_1(friendlies) / 2)) ? 0 : 1) | 0;
            }) : ((_arg) => (equals(_arg[1].victors, singleton(1)) ? 1 : 0))), runs, {
                GetZero: () => 0,
                Add: (x_1, y_1) => (x_1 + y_1),
            }) | 0;
            results = add(n_1, [victories, sampleLog], results);
            return FSharpMap__get_Item(results, n_1);
        }
    };
    const matchValue = filter((n_3) => betweenInclusive_1(~~(minbound * 10), ~~(maxbound * 10), get$(n_3)[0]), (loop = ((n_2) => {
        if ((get$(n_2)[0] > 0) && (n_2 <= 100)) {
            return cons(n_2, loop(n_2 + 1));
        }
        else {
            return empty();
        }
    }), loop(1)));
    if (isEmpty(matchValue)) {
        return [void 0, void 0, void 0];
    }
    else {
        const inbounds_1 = matchValue;
        const min = min_2(inbounds_1, {
            Compare: comparePrimitives,
        }) | 0;
        const max = max_2(inbounds_1, {
            Compare: comparePrimitives,
        }) | 0;
        return [min, max, get$(max)[1]];
    }
}

//# sourceMappingURL=FightExecution.fs.js.map
